import FreeLine from './FreeLine';

// Just an alias.
export default FreeLine;
